import React from 'react';
import { Field, useFormikContext } from 'formik';
import dayjs from 'dayjs';

import { FormErrorUI, FormLabelUI, InputUI, AutoCompleteSelectUI, TimePickerUi, CheckboxUI, SelectUI } from '../Interface';

const ProjectAndTaskSettingFields = ({ viewField, autoCompleteOptions }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();
  return (
    <div className="grid grid-cols-6 gap-x-4 mx-4 mb-5">
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="number"
          name="defTaskDuration"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Alapértelmezett feladat időintervallum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defTaskDuration} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defTaskDuration && values.defTaskDuration !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="defTaskFromTime"
          component={TimePickerUi}
          fullWidth
          label={<FormLabelUI text="Alapértelmezett feladat kezdő időpont" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defTaskFromTime} />}
          onChange={(value) => {
            const iso = value ? dayjs.utc(`1970-01-01T${value.format('HH:mm')}:00`).toISOString() : null;

            setFieldValue('defTaskFromTime', iso).then(() => {
              validateField('defTaskFromTime');
            });
          }}
          value={values.defTaskFromTime ? dayjs.utc(values.defTaskFromTime) : null}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defTaskFromTime !== '' }}
        />
      </div>

      <div className="col-span-4 md:col-span-1">
        <Field
          name="defTaskToTime"
          component={TimePickerUi}
          fullWidth
          label={<FormLabelUI text="Alapértelmezett feladat befejező időpont" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defTaskToTime} />}
          onChange={(value) => {
            const iso = value ? dayjs.utc(`1970-01-01T${value.format('HH:mm')}:00`).toISOString() : null;

            setFieldValue('defTaskToTime', iso).then(() => {
              validateField('defTaskToTime');
            });
          }}
          value={values.defTaskToTime ? dayjs.utc(values.defTaskToTime) : null}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defTaskToTime !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="defTaskQtyUnit"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Alapértelmezett feladat ME." />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defTaskQtyUnit} />}
          onChange={(_e, newVal) => {
            setFieldValue('defTaskQtyUnit', newVal?.value ?? null).then(() => {
              validateField('defTaskQtyUnit');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defTaskQtyUnit !== '' }}
          selectedValue={values.defTaskQtyUnit}
          dataset={autoCompleteOptions.timeQtyUnit}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="generateProjWorkingNumber"
          type="checkbox"
          as={CheckboxUI}
          fullWidth
          label={<FormLabelUI text="Projekt munkaszám auto. gen." />}
          disabled={viewField}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          type="autocomplete"
          name="defTaskListReportQtyUnit"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Feladatlista lejelentő alap. ME." />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defTaskListReportQtyUnit} />}
          onChange={(_e, newVal) => {
            setFieldValue('defTaskListReportQtyUnit', newVal?.value ?? null).then(() => {
              validateField('defTaskListReportQtyUnit');
            });
          }}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defTaskListReportQtyUnit !== '' }}
          selectedValue={values.defTaskListReportQtyUnit}
          dataset={autoCompleteOptions.timeQtyUnit}
        />
      </div>
      <div className="md:col-span-3 xl:col-span-1 col-span-6">
        <Field
          type="number"
          name="defTaskListReportTimeSpent"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Feladatlista lejelentő alap. időintervallum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defTaskListReportTimeSpent} />}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defTaskListReportTimeSpent && values.defTaskListReportTimeSpent !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="defTaskListReportFromTime"
          component={TimePickerUi}
          fullWidth
          label={<FormLabelUI text="Lejelentő alap. kezdő időpont" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defTaskListReportFromTime} />}
          onChange={(value) => {
            const iso = value ? dayjs.utc(`1970-01-01T${value.format('HH:mm')}:00`).toISOString() : null;

            setFieldValue('defTaskListReportFromTime', iso).then(() => {
              validateField('defTaskListReportFromTime');
            });
          }}
          value={values.defTaskListReportFromTime ? dayjs.utc(values.defTaskListReportFromTime) : null}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defTaskListReportFromTime !== '' }}
        />
      </div>
      <div className="col-span-4 md:col-span-1">
        <Field
          name="defTaskListReportToTime"
          component={TimePickerUi}
          fullWidth
          label={<FormLabelUI text="Lejelentő alap. befejező időpont" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.defTaskListReportToTime} />}
          onChange={(value) => {
            const iso = value ? dayjs.utc(`1970-01-01T${value.format('HH:mm')}:00`).toISOString() : null;

            setFieldValue('defTaskListReportToTime', iso).then(() => {
              validateField('defTaskListReportToTime');
            });
          }}
          value={values.defTaskListReportToTime ? dayjs.utc(values.defTaskListReportToTime) : null}
          disabled={viewField}
          InputLabelProps={{ shrink: values.defTaskListReportToTime !== '' }}
        />
      </div>
      <div className="col-span-6 border rounded p-4 mt-4">
        <h3 className="font-semibold mb-3">Projektlejelentő beállításai</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <AutoCompleteSelectUI
            fullWidth
            label="Alapértelmezett munkalap"
            dataset={autoCompleteOptions.worksheet}
            selectedValue={values.employeeAttendanceWorksheetId ?? null}
            onChange={(_event, selected) => setFieldValue('employeeAttendanceWorksheetId', selected?.value ?? null)}
            disabled={viewField}
            variant="standard"
          />
          <SelectUI
            label="Munkalap kiválasztásának módja"
            value={values.employeeAttendanceWorksheetMode ?? 'DEFAULT'}
            option={[
              { value: 'DEFAULT', label: 'Alapértelmezett munkalap' },
              { value: 'COMPANY_LOCATION', label: 'Projekt telephelye alapján' },
            ]}
            onChange={(event) => setFieldValue('employeeAttendanceWorksheetMode', event.target.value)}
            disabled={viewField}
          />
        </div>
        <p className="text-sm mt-3">
          Új mobilos projektlejelentés mentése után megnyílik a kiválasztott munkalap.
          Telephelyi beállítás hiányában az alapértelmezett munkalapot használjuk.
          Ha nincs megadva munkalap, nem nyílik meg kitöltő.
        </p>
      </div>
    </div>
  );
};

export default ProjectAndTaskSettingFields;
